import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import CoreJsonAPIService from './CoreJsonAPIService';
import { type ISortingMeta } from '../models/ISortingMeta';
import { type TPandasDataFrameDict } from '../components/TPandasDataFrameDict';
import { type IAugmentedBackendResponse } from '../models/IAugmentedBackendResponse';

export interface NotificationDTO {
  id: string;
  createdTs: string;
  desc: { title: string; detail: string };
  url?: string | null;
  modalText?: string | null;
}

export class SvNotificationsService extends CoreJsonAPIService {
  static async getNotifications(params: { page: number; sorting: ISortingMeta }) {
    return await super.get<IAugmentedBackendResponse<TPandasDataFrameDict>>(
      EDjangoAppsEndpoints.notifications,
      '',
      {
        page: params.page,
        sortCol: params.sorting.sortCol,
        ascending: params.sorting.ascending
      }
    );
  }

  static async markNotificationComplete(notificationId: string) {
    return await super.put<NotificationDTO>(
      EDjangoAppsEndpoints.notifications,
      notificationId
    );
  }
}
